import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function M365SettingsPage() {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to the main M365 integration page since seamless connection
    // no longer requires manual Azure AD setup
    navigate('/m365-integration', { replace: true });
  }, [navigate]);

  return null;
}
